module.exports = __webpack_public_path__ + "static/media/kz-online-avatar.a2a671e4.png";